module.exports = __webpack_public_path__ + "static/zain-d8e35d287dfbc604479e31d1076198d7.png";